import { render, staticRenderFns } from "./ExcelEditor.vue?vue&type=template&id=fe80a24c"
import script from "./ExcelEditor.vue?vue&type=script&lang=js"
export * from "./ExcelEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports